import { create } from 'zustand';

/**
 * Living help panel state (ADR-0066). Not persisted: the panel starts closed on every load, and
 * the current screen's PB window is whatever the mounted {@code ScreenHelpButton} reports.
 *
 * <ul>
 *   <li>{@code pbWindow}: set by {@code ScreenHelpButton} on mount (dev-rules §4.15 keeps its
 *       {@code pbWindow} prop required) and cleared on unmount. The panel header and its
 *       "Report an issue" footer use it (it is the feedback {@code screenId}).</li>
 *   <li>{@code pendingHighlight}: a {@code data-help-id} to pulse once the screen that a
 *       cross-screen chip ({@code /route#id}) navigated to has mounted it.</li>
 * </ul>
 */
export interface HelpPanelState {
  open: boolean;
  pbWindow: string | null;
  pendingHighlight: string | null;
  openPanel(): void;
  closePanel(): void;
  toggle(): void;
  setScreen(pbWindow: string | null): void;
  setPendingHighlight(id: string | null): void;
}

export const useHelpPanelStore = create<HelpPanelState>()((set) => ({
  open: false,
  pbWindow: null,
  pendingHighlight: null,
  openPanel: () => set({ open: true }),
  closePanel: () => set({ open: false }),
  toggle: () => set((s) => ({ open: !s.open })),
  setScreen: (pbWindow) => set({ pbWindow }),
  setPendingHighlight: (id) => set({ pendingHighlight: id }),
}));
